import axios from 'axios';
import { AssistQueryClient } from 'services/assist-api/query-client';

type Props = { username: string; password: string };

export type LoginResult = {
  token: string;
  refresh_token: string;
};

export const postLogin = async ({ username, password }: Props): Promise<LoginResult> => {
  const tokenData = await axios.post<LoginResult>(`${BACKEND_URL}/tokens`, { username, password });
  AssistQueryClient.invalidateQueries(['user']);
  return tokenData.data;
};
